(function () {

  'use strict';

  function remoteQueueManagement(
    PRINT_QUEUE_LIST_FILTERS, WORKSTATIONS_FILTERS, GROUP_EXTERNAL_FILTERS, PrintQueueListService, FilterDropdownService, TenantListService, PrintQueueListPaging,
    NetworkListService, $window, localStorageService, $location, WorkstationListService, SUPPORTED_OS, $filter, GroupExternalListService, toastr, GroupListService,
    GroupListPaging, GroupExternalListPaging, $timeout, $rootScope, NetworkListPaging, GroupListPOSTPaging, GroupFilterModel) {
    return {
      restrict: 'EA',
      scope: {
        calibrationObject: '=calibrationObject',
        openRemoteQueueManagement: '&',
        closeRemoteQueueManagement: '&',
        renderItems: '&renderItems',
        callback: '&callback'
      },
      templateUrl: 'app/directives/remoteQueueManagementDirective/remote-queue-management.template.html',
      link: function (scope, element, attrs) {

        scope.itemListPaging = scope.calibrationObject.pagingObject;
        scope.filtersList = null;
        scope.networkListService = NetworkListService;
        scope.requestType = scope.calibrationObject.pagingRequestType;
        scope.searchInputPlaceholderText = scope.calibrationObject.searchInputPlaceholderText;
        scope.searchPattern = '';
        scope.stagedItemsContainer = [];
        scope.itemsContainer = null;
        scope.noStagedItems = true;
        scope.originalModel = scope.calibrationObject.originalModel;
        scope.presetFilters = [];
        scope.openModalDialog = false;
        scope.directiveScope = null;
        scope.gettingData = true;
        scope.tooltip = translateTooltip();
        scope.hideList = false;
        scope.tooltipGroupManagement = {
          GroupExclusiveAccessWarningTooltip: 'GroupExclusiveAccessWarningTooltip',
          SynchronizeAllGroupsTooltip: 'SynchronizeAllGroupsTooltip'
        }

        // DYNAMIC UI
        scope.autoAdjustModalHeight = true;

        // GROUPS
        scope.groupsWithExclusiveAccess = false;
        scope.groupSettings = {
          setGroupAutoInstall: false,
          setAsDefaultPrinter: false,
          setGroupExclusiveAccess: false
        };
        scope.showUnSyncGroups = false;
        scope.synchronizingGroupsIsOngoing = false;

        //*****************//
        // INIT
        // -----------------
        // Remove unwanted filter
        // Reset breakerFlag
        // Wait for networks before filtersUI can be initialized
        //*****************//
        (function () {
          setDirectiveScope();
          getWorkstationNetwork();
          scope.filtersList = setFilters()
          checkForStagedElements();
        }())

        function setDirectiveScope() {
          if (scope.calibrationObject.context === 'addManyQueuesToOneWorkstation') {
            scope.directiveScope = 'manyToOne';
          } else if (scope.calibrationObject.context === 'addOneQueuToManyWorkstations') {
            scope.directiveScope = 'oneToMany';
          } else if (scope.calibrationObject.context === 'distributeQueueToQueues') {
            scope.directiveScope = 'distributeQueue';
          } else if (scope.calibrationObject.context === 'queueGroupManagement') {
            scope.directiveScope = 'queueGroupManagement';
          } else if (scope.calibrationObject.context === 'tenantGroupManagement') {
            scope.directiveScope = scope.calibrationObject.context;
          }
        }

        function getWorkstationNetwork() {
          if (scope.directiveScope !== 'tenantGroupManagement' && scope.calibrationObject.originalModel.info._embedded.adapters) {
            var network = scope.calibrationObject.originalModel.info._embedded.adapters[0]._links['px:network'];
            if (network) {

              NetworkListService.getNetworkModelByUrl(network.href).then(function(network) {
                scope.gettingData = false;
                var filter = {
                  name: 'Network',
                  parameter: 'networks',
                  key: network.info._links.self.href,
                  type: 'pagination',
                  value: network.info.name,
                  state: true
                }

                scope.presetFilters.push(filter);
              }).catch(function(error){});
            }
          } else {
            scope.gettingData = false;
          }
        }

        function setFilters()  {
          var filters;
          if (scope.directiveScope === 'manyToOne' || scope.directiveScope === 'distributeQueue') {
            filters = angular.copy(PRINT_QUEUE_LIST_FILTERS);
            filters[0].paginationObject = new NetworkListPaging();
            filters = suppressRangeFilter(filters);
            filters = setBreaker(filters);
          } else if (scope.directiveScope === 'oneToMany') {
            filters = angular.copy(WORKSTATIONS_FILTERS);
            filters[0].paginationObject = new NetworkListPaging();
            filters[1].values = FilterDropdownService.addInputType(scope.calibrationObject.supportedOs);
          } else if (scope.directiveScope === 'queueGroupManagement' || scope.directiveScope === 'tenantGroupManagement') {
            filters = new GroupFilterModel('GROUP_QUEUE_MANAGEMENT').filters;
          }
          return filters;
        }

        function suppressRangeFilter(filters) {
          filters.splice(1, 1);
          return filters;
        }

        function setBreaker(filters) {
          filters[0].setBreaker = true;
          return filters;
        }

        function translateTooltip() {
          if (scope.calibrationObject.tooltip) {
            var tooltip = $filter("stringular")($filter("translate")(scope.calibrationObject.tooltip))
            if (tooltip !== scope.calibrationObject.tooltip) {
              return tooltip;
            }
          }
          return '';
        }

        //*****************//
        // Getting queues/paging
        // -----------------
        // Excluding queues before requesting add-able items
        //*****************//
        scope.getItemsListPaged = function () {
          excludeItems();
          if (TenantListService.currentTenant && TenantListService.currentTenant.info) {
            if (scope.directiveScope === 'manyToOne' || scope.directiveScope === 'distributeQueue') {
              PrintQueueListService.getPrintQueueListPaged(scope.itemListPaging).then(function (itemsContainer) {
                scope.itemsContainer = checkForStagedElements(itemsContainer);
              }).catch(function(error){});
            } else if (scope.directiveScope === 'oneToMany') {
              WorkstationListService.postGetWorkstationListPaged(scope.itemListPaging).then(function (itemsContainer) {
                scope.itemsContainer = checkForStagedElements(itemsContainer);
              }).catch(function(error){});
            } else if (scope.directiveScope === 'tenantGroupManagement') {
              GroupExternalListService.getGroupExernalListPagedPOST(scope.itemListPaging).then(function (itemsContainer) {
                scope.itemsContainer = checkForStagedElements(itemsContainer);
              }).catch(function(error){});
            } else if (scope.directiveScope === 'queueGroupManagement') {
              scope.itemListPaging.pagingCriteria.exclude = scope.calibrationObject.originalModel.groupList.map(group => group.info._links.self.href);
              scope.itemListPaging.pagingCriteria.queueFilterMode = null;
              scope.itemListPaging.pagingCriteria.queue = scope.calibrationObject.originalModel.info._links.self.href;
              GroupListService.getGroupListPagedByPost(scope.itemListPaging).then(function (itemsContainer) {
                scope.itemsContainer = checkForStagedElements(itemsContainer);
              }).catch(function(error){});
            }
          } else {
            var watch = scope.$watch(function () {
              return TenantListService.currentTenant;
            }, function () {
              if (TenantListService.currentTenant && TenantListService.currentTenant.info) {
                watch();
                scope.getItemsListPaged();
              }
            }, true);
          }
        }

        function excludeItems() {
          var excludedItems = [];
          if (scope.directiveScope !== 'tenantGroupManagement') {
            scope.excludedItems = scope.calibrationObject.originalModel.info._embedded.queues;
            if (scope.excludedItems) {
              for (var i = 0; i < scope.excludedItems.length; i++) {
                excludedItems.push(scope.excludedItems[i]._links['px:queue'].href);
              }
            } else if (scope.directiveScope === 'distributeQueue') {
              excludedItems.push(scope.calibrationObject.originalModel.info._links.self.href);
            }
          }
          setPagingCriteria(excludedItems);
        }

        function setPagingCriteria(excludedItems) {
          if (scope.directiveScope === 'manyToOne' || scope.directiveScope === 'distributeQueue') {
            scope.itemListPaging.pagingCriteria.excludeQueues = excludedItems;
          } else if (scope.directiveScope === 'oneToMany') {
            scope.itemListPaging.pagingCriteria.queueFilterMode = 'NOT_PRESENT';
            scope.itemListPaging.pagingCriteria.queue = scope.calibrationObject.originalModel.info._links.self.href;
          } else if (scope.directiveScope === 'tenantGroupManagement') {
            scope.itemListPaging.pagingCriteria.queueFilterMode = 'NOT_PRESENT';
          } else if (scope.directiveScope === 'queueGroupManagement') {
            scope.itemListPaging.pagingCriteria.queueFilterMode = 'PRESENT_ON_ANY_EXCEPT';
            scope.itemListPaging.pagingCriteria.queue = scope.calibrationObject.originalModel.info._links.self.href;
          }
          scope.itemListPaging.pagingCriteria.pageSize = 10;
        }

        scope.initiateSearch = function () {
          angular.element('.paged-items').detach();
          var searchString = scope.searchPattern.toLowerCase();
          if (searchString) {
            scope.itemListPaging.pagingCriteria.match = searchString;
          } else {
            scope.itemListPaging.pagingCriteria.match = null;
          }
          scope.itemListPaging.pagingCriteria.page = 0;
          scope.getItemsListPaged();
        }


        //*****************//
        // Sanitizing the stagedItemsList
        // -----------------
        // Toggle submitButtonStatus state disabled:true/false if list is empty
        //*****************//
        function checkForStagedElements(itemsContainer) {
          for (var i = 0; i < scope.stagedItemsContainer.length; i++) {
            for (var j = 0; j < itemsContainer.list.length; j++) {
              if (scope.stagedItemsContainer[i].info._links.self.href === itemsContainer.list[j].info._links.self.href || itemsContainer.list[j].customProperties.staged) {
                itemsContainer.list[j].customProperties.staged = true;
              } else {
                itemsContainer.list[j].customProperties.staged = false;
              }
            }
          }
          return itemsContainer;
        }

        function submitButtonStatus() {
          if (scope.stagedItemsContainer.length > 0) {
            scope.noStagedItems = false;
          } else {
            scope.noStagedItems = true;
          }
        }


        //*****************//
        // Events
        // -----------------
        //*****************//
        scope.addItemToStaging = function (item) {
          item.customProperties.staged = true;
          if (scope.stagedItemsContainer.length <= 0) {
            scope.stagedItemsContainer.push(item);
          } else {
            if (!isItemStaged(item)) {
              scope.stagedItemsContainer.push(item);
            }
          }
          submitButtonStatus();
        }

        function isItemStaged(item) {
          var itemIsStaged = false;
          for (var i = 0; i < scope.stagedItemsContainer.length; i++)  {
            if (scope.stagedItemsContainer[i].info._links.self.href === item.info._links.self.href) {
              itemIsStaged = true;
            }
          }
          return itemIsStaged;
        }

        scope.removeItemFromStaging = function (item) {
          for (var i = 0; i < scope.stagedItemsContainer.length; i++) {
            if (scope.stagedItemsContainer[i].info._links.self.href === item.info._links.self.href) {
              scope.stagedItemsContainer.splice(i, 1);
            }
          }

          for (var j = 0; j < scope.itemsContainer.list.length; j++) {
            if (scope.itemsContainer.list[j].info._links.self.href === item.info._links.self.href) {
              scope.itemsContainer.list[j].customProperties.staged = false;
            }
          }
          submitButtonStatus();
        }

        scope.addAllItems = function () {
          for (var i = 0; i < scope.itemsContainer.list.length; i++) {
            if (!scope.itemsContainer.list[i].customProperties.staged) {
              scope.itemsContainer.list[i].customProperties.staged = true;
              scope.stagedItemsContainer.push(scope.itemsContainer.list[i]);
            }
          }
          submitButtonStatus();
        }

        scope.removeAllItems = function () {
          scope.stagedItemsContainer = [];
          for (var i = 0; i < scope.itemsContainer.list.length; i++) {
            scope.itemsContainer.list[i].customProperties.staged = false;
          }
          submitButtonStatus();
        }

        scope.toggleGroupSource = function () {
          scope.showUnSyncGroups = !scope.showUnSyncGroups;
          scope.hideList = true;
          scope.searchPattern = '';
          if (scope.showUnSyncGroups) {
            checkForOngoingGroupSyncTask();
            scope.itemListPaging = new GroupListPOSTPaging();
            scope.itemListPaging.pagingCriteria.pageSize = 10;
            scope.itemListPaging.pagingCriteria.queueFilterMode = 'NOT_PRESENT';
            scope.itemListPaging.pagingCriteria.queue = scope.calibrationObject.originalModel.info._links.self.href;
            GroupExternalListService.getGroupExernalListPagedPOST(scope.itemListPaging).then(function (itemsContainer) {
              scope.itemsContainer = [];
              scope.itemsContainer = checkForStagedElements(itemsContainer);
              $timeout(function () {
                scope.hideList = false;
              }, 500)
              scope.removeAllItems();
            }).catch(function(error){
              toastr.error($filter("translate")("SomethingWentWrong"));
            });
          } else {
            scope.itemListPaging = new GroupListPOSTPaging();
            scope.itemListPaging.pagingCriteria.pageSize = 10;
            scope.itemListPaging.pagingCriteria.queueFilterMode = 'PRESENT_ON_ANY_EXCEPT';
            scope.itemListPaging.pagingCriteria.queue = scope.calibrationObject.originalModel.info._links.self.href;
            GroupListService.getGroupListPagedByPost(scope.itemListPaging).then(function (itemsContainer) {
              scope.itemsContainer = [];
              scope.itemsContainer = checkForStagedElements(itemsContainer);
              $timeout(function () {
                scope.hideList = false;
              }, 500)
              scope.removeAllItems();
            }).catch(function(error){});
          }
        }

        function checkForOngoingGroupSyncTask () {
          scope.synchronizingGroupsIsOngoing = $rootScope.synchronizingGroupsIsOngoing;
          scope.$watch(function(){
            return $rootScope.synchronizingGroupsIsOngoing;
          }, function(){
            if (!$rootScope.synchronizingGroupsIsOngoing) {
              scope.ongoingGroupSync = false;
            } else {
              scope.ongoingGroupSync = true;
            }
          }, true)
        }

        scope.synchronizeGroups = function ()  {
          angular.element('#addPrintQueuesDialog').modal('hide');
          toastr.success($filter("translate")("GroupsSynchronizationStarted"));
          scope.cancelDialog();
          $rootScope.synchronizingGroupsIsOngoing = true;
          scope.ongoingGroupSync = true;
          GroupExternalListService.reloadGroupsFromProviders().then(function(response){
            $rootScope.synchronizingGroupsIsOngoingTaskId = response.data.taskId;
          }).catch(function(error){});
        }

        scope.submitStagedItems = function () {
          if (scope.directiveScope === 'manyToOne') {
            scope.calibrationObject.originalModel.addSelectedPrintQueues(scope.stagedItemsContainer);
            scope.callback({printQueues: scope.stagedItemsContainer})
          } else if (scope.directiveScope === 'oneToMany') {
            scope.calibrationObject.originalModel.addQueueToComputers(scope.stagedItemsContainer);
          } else if (scope.directiveScope === 'distributeQueue') {
            scope.calibrationObject.originalModel.distributePrintQueueConfigToPrintQueues(scope.stagedItemsContainer);
          } else if (scope.directiveScope === 'tenantGroupManagement') {
            scope.calibrationObject.originalModel.addExternalGroupsBulkToTenant(scope.stagedItemsContainer);
          }

          clearStagedItems();
        }

        scope.cancelDialog = function () {
          clearStagedItems();
          clearGroupSettings();
        }

        function clearStagedItems() {
          scope.closeRemoteQueueManagement();
          scope.openModalDialog = false;
          scope.stagedItemsContainer = [];
          localStorageService.remove($location.$$path);
        }

        scope.getNextPage = function functionName(showPrevious) {
          angular.element('.paged-items').detach();
          if (showPrevious) {
            if (scope.itemListPaging.pagingCriteria.page > 0) {
              scope.itemListPaging.pagingCriteria.page--;
            }
          } else {
            if (scope.itemListPaging.pagingCriteria.page + 1 < scope.itemsContainer.page.totalPages) {
              scope.itemListPaging.pagingCriteria.page++;
            }
          }
          scope.getItemsListPaged();
        }

        scope.openRemoteQueueManagementDialog = function () {
          scope.openRemoteQueueManagement();
          submitButtonStatus();
          scope.openModalDialog = true;
          angular.element('#addPrintQueuesDialog').modal('show');
        }

        scope.goBackToPreviousModal = function () {
          submitButtonStatus();
          scope.openModalDialog = true;
          angular.element('#addPrintQueuesDialog').modal('show');
        }

        // GROUPS
        scope.openGroupMultiEditDialog = function ()  {
          scope.autoAdjustModalHeight = false;
          angular.element('#multiEditGroupsDialog').modal('show');
        }

        scope.removeGroup = function (group) {
          for (var i = 0; i < scope.stagedItemsContainer.length; i++) {
            if (scope.stagedItemsContainer[i].info._links.self.href === group.info._links.self.href) {
              scope.stagedItemsContainer.splice(i, 1);
            }
          }
        }


        scope.anyGroupsHasExclusiveAccess = function () {
          if (scope.calibrationObject.originalModel.info._links['px:group'] && !scope.groupSettings.setGroupExclusiveAccess) {
            scope.groupsWithExclusiveAccess = true;
          } else {
            scope.groupsWithExclusiveAccess = false;
          }
          return scope.groupsWithExclusiveAccess;
        }

        scope.submitGroups = function () {
          var groups = [];
          for (var i = 0; i < scope.stagedItemsContainer.length; i++) {
            var group = {
              groupId: scope.stagedItemsContainer[i].info._links.self.href,
              exclusiveAccess: scope.groupSettings.setGroupExclusiveAccess,
              autoInstall: scope.groupSettings.setGroupAutoInstall,
              defaultQueue: scope.groupSettings.setAsDefaultPrinter
            }
            groups.push(group);
          }
          scope.calibrationObject.originalModel.addGroupsToQueue(groups).then(function () {
            toastr.success($filter("translate")("ChangesSaved"));
          }).catch(function(error){
            toastr.error($filter("translate")("error"));
          });
          clearStagedItems();
          clearGroupSettings();
        }

        function clearGroupSettings() {
          scope.showUnSyncGroups = false;
          scope.groupSettings.setGroupExclusiveAccess = false;
          scope.groupSettings.setGroupAutoInstall = false;
          scope.groupSettings.setAsDefaultPrinter = false;
          scope.itemsContainer.list = [];
          angular.element('#multiEditGroupsDialog').modal('hide');
        }

        scope.enableSubmitButton = function () {
          if (scope.groupSettings.setGroupExclusiveAccess || scope.groupSettings.setGroupAutoInstall || scope.groupSettings.setAsDefaultPrinter) {
            return false;
          }
          return true;
        }

        // DYNAMIC RESIZE UI
        angular.element($window).on('resize', function () {
          resizeDialogModal($window.innerHeight);
          // manually $digest required as resize event is outside of angular
          scope.$digest();
        });

        function resizeDialogModal(height) { // TODO subtract 120 from base value
          if (scope.autoAdjustModalHeight) {
            if (height < 720) {
              angular.element('.list-content').css({ height: 260 });
              angular.element('.fake-box').css({ height: 315 });
              angular.element('.modal-list-container').css({ height: 315 });
              angular.element('.modal-body').css({ height: 510 });
            } else {
              angular.element('.list-content').css({ height: 380 });
              angular.element('.fake-box').css({ height: 435 });
              angular.element('.modal-list-container').css({ height: 435 });
              angular.element('.modal-body').css({ height: 630 });
            }
          }
        }

      }
    };
  }

  remoteQueueManagement.$inject = ['PRINT_QUEUE_LIST_FILTERS', 'WORKSTATIONS_FILTERS', 'GROUP_EXTERNAL_FILTERS', 'PrintQueueListService', 'FilterDropdownService', 'TenantListService', 'PrintQueueListPaging',
    'NetworkListService', '$window', 'localStorageService', '$location', 'WorkstationListService', 'SUPPORTED_OS', '$filter', 'GroupExternalListService', 'toastr', 'GroupListService',
    'GroupListPaging', 'GroupExternalListPaging', '$timeout', '$rootScope', 'NetworkListPaging', 'GroupListPOSTPaging', 'GroupFilterModel'];

  angular
    .module('printix-admin')
    .directive('remoteQueueManagement', remoteQueueManagement);

})();
